import {Init,} from 'core/Init';
import {APP_EVT, APP_LOCATION, APP_ROLE, SERIES_ID} from "core/config/constants";
import {Params} from 'core/services/Params';


import {Attachable} from "core/items/base/Attachable";


class Stage {

	private _active = false;
	private _currentX;
	private _currentY;
	private _initialX;
	private _initialY;

	constructor() {

		Init.emitter.on(APP_EVT.TOGGLE_MENU, this.toggleMenu);
		Init.emitter.on(APP_EVT.MENU_ITEM_MOUSE_OVER, this.showItemData);
		Init.emitter.on(APP_EVT.CLICKCLIP_MOUSE_OUT, this.hideItemData);
		Init.emitter.on(APP_EVT.MENU_ITEM_MOUSE_OUT, this.hideItemData);

		Init.emitter.on(APP_EVT.STAGE_MOUSE_UP, this.handleStageMouseUp);
		Init.emitter.on(APP_EVT.CLICKCLIP_MOUSE_OVER, this.triggerItemData);


		let _that = this;

		if (Init.app_role != APP_ROLE.THUMB) {

			//$('#svg-logo-box').css({'left': '360px'});

			$('#svg-logo-box').on('mouseover', function () {

				$('#svg-logo-box .handle').show();
				$('#svg-logo-box .bg').addClass('active');

			})
				.on('mouseout', function () {

					$('#svg-logo-box .handle').hide();
					$('#svg-logo-box .bg').removeClass('active');

				});


			$('#svg-logo-box .handle').on('mousedown', function (e) {

				e.stopPropagation();

				_that.dragStart(e, 'logo');

				$('#design-frame').on('mousemove', function (e) {
					_that.drag(e, 'logo');
				})
					.on('mouseup', function (e) {
						_that.dragEnd(e, 'logo');
					});

			});


			$('#panel-design-notes .handle .dragger').on('mousedown', function (e) {

				e.stopPropagation();

				_that.dragStart(e, 'notes');

				$('#design-frame').on('mousemove', function (e) {
					_that.drag(e, 'notes');
				})
					.on('mouseup', function (e) {
						_that.dragEnd(e, 'notes');
					});

			});


			$('#svg-stage').on('mousedown', function (e) {

				//console.log('svg-stage');

				if (!Init.roofs_active) {

					e.stopPropagation();

					//console.log('mousedown');
					_that.dragStart(e, 'design');

					$(document).on('mouseup', function (e) {
						_that.dragEnd(e, 'design');
					});
					//
					$(document).on('mousemove', function (e) {
						_that.drag(e, 'design');
					});
				}
			});

			if (Init.is_touch_device === true) {

				$('#svg-stage').on('touchstart', function (e) {
					//console.log('touchstart');
					switch (e.touches.length) {

						case 2:

							let tpCache = new Array();

							if (e.targetTouches.length == 2 && e.changedTouches.length == 2) {
								// Check if the two target touches are the same ones that started
								// the 2-touch
								var point1 = -1, point2 = -1;
								for (var i = 0; i < tpCache.length; i++) {
									if (tpCache[i].identifier == e.targetTouches[0].identifier) point1 = i;
									if (tpCache[i].identifier == e.targetTouches[1].identifier) point2 = i;
								}
								if (point1 >= 0 && point2 >= 0) {
									// Calculate the difference between the start and move coordinates
									var diff1 = Math.abs(tpCache[point1].clientX - e.targetTouches[0].clientX);
									var diff2 = Math.abs(tpCache[point2].clientX - e.targetTouches[1].clientX);

									// This threshold is device dependent as well as application specific
									var PINCH_THRESHOLD = e.target.clientWidth / 10;
									if (diff1 >= PINCH_THRESHOLD && diff2 >= PINCH_THRESHOLD)
										$('#svg-logo-box .design_name').text(diff1 + ' ' + diff2);
									console.log(diff1, diff2);
								} else {
									// empty tpCache
									tpCache = new Array();
								}
							}
							break;

						default:

							_that.dragStart(e.changedTouches[0], 'design');

							$(document).on('touchcancel', function (e) {
								_that.dragEnd(e.changedTouches[0], 'design');
							});

							$(document).on('touchend', function (e) {
								_that.dragEnd(e.changedTouches[0], 'design');
							});
							//
							$(document).on('touchmove', function (e) {
								_that.drag(e.changedTouches[0], 'design');
							});
							break;
					}

					e.preventDefault();
				});
			}
		}
	};


	dragStart = (e, item: any): void => {

		Init.emitter.emit(APP_EVT.STAGE_DRAG_START);

		let o;
		let adj: number = 0;

		if (item == 'logo') {

			o = $('#svg-logo-box').position();

		} else if (item == 'notes') {

			o = $('#panel-design-notes').position();

		} else {

			o = $('#svg-stage').position();
			$('#svg-stage').addClass('grabbing');
			adj = 50;
		}


		this._initialX = e.clientX - o.left;
		this._initialY = e.clientY - (o.top - adj);

		this._active = true;

	};


	drag = (e, item: any): void => {

		if (this._active) {

			if (item == 'logo') {

				this._currentX = e.clientX - this._initialX;
				this._currentY = e.clientY - this._initialY;
				$('#svg-logo-box').css('top', this._currentY + 'px').css('left', this._currentX + 'px');

			} else if (item == 'notes') {

				this._currentX = e.clientX - this._initialX;
				this._currentY = e.clientY - this._initialY;
				$('#panel-design-notes').css('top', this._currentY + 'px').css('left', this._currentX + 'px');

			} else {

				this._currentX = e.clientX - this._initialX;
				this._currentY = e.clientY - this._initialY;

				// call this using the emitter so that things like post labels which are in separate SVG levels
				// can move along with the design.
				Init.emitter.emit(APP_EVT.MOVE_DESIGN, this._currentX, this._currentY);
				//Init.manipulate.moveDesign(this._currentX, this._currentY);

				this._initialX = e.clientX;
				this._initialY = e.clientY;
			}

		}
	};


	dragEnd = (e, item: any): void => {

		this._active = false;

		if (item == 'logo') {

			$('#design-frame').off('mousemove mouseup');

		} else if (item == 'logo') {

			$('#panel-design-notes').off('mousemove mouseup');

		} else {

			$(document).off('mousemove mouseup touchcancel touchend touchmove');
			$('#svg-stage').removeClass('grabbing');

		}
	};


	toggleMenu = (): void => {

		if ($('#sidebar').position().left == 0) {

			$('#sidebar').animate({left: '-360'}, 500, 'easeOutQuart', function () {
				$('#sidebar #items').hide()
			});

		} else {

			$('#sidebar').animate({left: '0', start: this.showItems()}, 500, 'easeOutQuart');

		}
	};


	handleStageMouseUp = (): void => {

		//console.log('handleStageMouseUp');

		if (Init.roofs_active !== true && Init.decks_active !== true && Init.floors_active !== true) {

			Init.emitter.emit(APP_EVT.DEACTIVATE_ITEM);

		}
	};


	showItems = (): void => {

		$('#sidebar>#items').show();

	};


	hideItems = (): void => {

		$('#sidebar>#items').hide();

	};


	/**
	 *
	 * @param item
	 */
	triggerItemData = (item: Attachable): void => {

		// only need to show product info if the tool is being used on the website
		if (Init.app_location == APP_LOCATION.WWW) {

			this.showItemData(item.itemId);

		}
	};


	/**
	 *
	 *
	 */
	showItemData(item_id: number): void {

		let params: any = Params.getItemData(item_id);

		switch (Init.series_id) {

			case SERIES_ID.ARCHITECTURAL:
			case SERIES_ID.CLASSIC:
			case SERIES_ID.RUSTIC:
				params = Params.getItem(item_id);
				break;

			case SERIES_ID.SERENDIPITY:
			case SERIES_ID.COMMERCIAL_OUTDOOR:
			case SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
				params = Params.getItemData(item_id);
				break;

		}

		// only need to show product info if the tool is being used on the website
		if (Init.app_location == APP_LOCATION.WWW
			&& Init.is_touch_device !== true
			&& params != undefined) {

			let item_name: string = params.item_name;
			let image_name: string = params.item_image;

			$('#item-image-frame').show();


			$('#item-image-frame .title').text(item_name);

			if (image_name != '') {
				$('#item-image-frame .image').html('<img src="' + Init.item_image_path + image_name + '" />');
			}

		} else {

			$('#item-image-frame').hide();

		}

	};


	/**
	 *
	 *
	 */
	hideItemData = (): void => {

		$('#item-image-frame').hide();

	};


}

export {Stage};

